import { graphConfig } from "./authConfig";

//const serviceUrl = "http://localhost:3001/safetybotsubscription";
const serviceUrl =
  "https://announcebotdashboardservice.azurewebsites.net/safetybotsubscription";
/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export async function callMsGraph(accessToken) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };
  return fetch(graphConfig.graphMeEndpoint, options)
    .then((response) => response.json())
    .catch((error) => console.log(error));
}

export function callLoginGraph() {
  return fetch(
    `https://announcebotdashboardservice.azurewebsites.net/getSafetyBotToken`
  )
    .then((response) => response.json())
    .catch((error) => console.log(error));
}

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export async function callSubscriptionResolve(accessToken, markatePlaceToken) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;
  headers.append("Authorization", bearer);
  headers.append("content-type", "application/json");
  headers.append("x-ms-marketplace-token", markatePlaceToken);
  const options = {
    method: "POST",
    headers: {
      Authorization: bearer,
      "content-type": "application/json",
      "x-ms-marketplace-token": markatePlaceToken,
    },
  };
  return fetch(
    "https://marketplaceapi.microsoft.com/api/saas/subscriptions/resolve?api-version=2018-08-31",
    options
  )
    .then((response) => response.json())
    .catch((error) => console.log(error));
}

export async function callSubscriptionActivate(
  accessToken,
  subscriptionId,
  subPlanId,
  subQuantity
) {
  const bearer = `Bearer ${accessToken}`;
  var myHeaders = new Headers();
  myHeaders.append("Authorization", bearer);
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  var urlencoded = new URLSearchParams();
  urlencoded.append("planId", subPlanId);
  urlencoded.append("quantity", subQuantity);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
  };

  fetch(
    `https://marketplaceapi.microsoft.com/api/saas/subscriptions/${subscriptionId}/activate?api-version=2018-08-31`,
    requestOptions
  )
    .then((response) => response.text())
    .catch((error) => console.log("error", error));
}

export async function getAllSubscriptions(accessToken) {
  const bearer = `Bearer ${accessToken}`;
  var myHeaders = new Headers();
  myHeaders.append("Authorization", bearer);
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
  };

  return fetch(
    `https://marketplaceapi.microsoft.com/api/saas/subscriptions?api-version=2018-08-31`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => console.log("error", error));
}

export async function getUserData(emailId, teamId) {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };

  const data = await fetch(
    `${serviceUrl}?type=getUserNameAndTeamMemberCount&emailId=${emailId}&teamId=${teamId}`,
    requestOptions
  )
    .then((response) => {
      return response.text();
    })
    .then((result) => JSON.parse(result))
    .catch((error) => console.log("error", error));
  return data;
}

export async function getSubscriptionById(accessToken, subscriptionId) {
  const bearer = `Bearer ${accessToken}`;
  var myHeaders = new Headers();
  myHeaders.append("Authorization", bearer);
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
  };

  return fetch(
    `https://marketplaceapi.microsoft.com/api/saas/subscriptions/${subscriptionId}?api-version=2018-08-31`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => console.log("error", error));
}

export async function cencelSubscription(accessToken, subscriptionId) {
  const bearer = `Bearer ${accessToken}`;
  var myHeaders = new Headers();
  myHeaders.append("Authorization", bearer);
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
  };

  return fetch(
    `https://marketplaceapi.microsoft.com/api/saas/subscriptions/${subscriptionId}?api-version=2018-08-31`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => console.log("error", error));
}

export async function getSubscriptionFromDatabase(emailId) {
  return fetch(
    `${serviceUrl}?type=getSafetyBotSubscription&emailid=${emailId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .catch((error) => console.log(error));
}

export async function saveSubscription(subscriptionDetails) {
  var subscriptionType = 3;
  var jsonFile = JSON.stringify(subscriptionDetails);
  var startDate = new Date().toISOString().split('T')[0];
  var endDate = new Date();
  if (subscriptionDetails.term.termUnit === "P1Y") {
    endDate = new Date(
      endDate.setDate(endDate.getDate() + 365)
    ).toISOString().split('T')[0];
  } else {
    endDate = new Date(
      endDate.setDate(endDate.getDate() + 31)
    ).toISOString().split('T')[0];
  }

  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };

  const data = await fetch(
    `${serviceUrl}/?type=updateSafetyBotSubscription&emailId=${subscriptionDetails.purchaser.emailId}&subscriptionType=${subscriptionType}&teamId=${subscriptionDetails.teamId}&userId=${subscriptionDetails.id}&subJson=${jsonFile}&quantity=${subscriptionDetails.quantity}&startDate=${startDate}&endDate=${endDate}&saasSubscriptionStatus=${subscriptionDetails.saasSubscriptionStatus}&subscriptionId=${subscriptionDetails.id}&termUnit=${subscriptionDetails.term.termUnit}&tenantId=${subscriptionDetails.beneficiary.tenantId}&action=${subscriptionDetails.saasSubscriptionStatus}`,
    requestOptions
  )
    .then((response) => {
      return response.text();
    })
    .then((result) => JSON.parse(result))
    .catch((error) => console.log("error", error));
  return data;
}

export async function licenseUpdate(List) {
  const batchSize = 500;
  const results = [];

  for (let i = 0; i < List.length; i += batchSize) {
    const batch = List.slice(i, i + batchSize);

    const result = await fetch(
      `${serviceUrl}?type=updateLicense`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userList: batch }),
      }
    );

    results.push(await result.json());
  }

  return results;
}

export async function getLicense(userEmailId) {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };

  return fetch(
    `${serviceUrl}?type=getUserIdUsingEmailId&emailId=${userEmailId}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => console.log("error", error));
}
